import { User } from '../../features/auth/types';

export const getAccessToken = (): string | null => localStorage.getItem('access_token');
export const setAccessToken = (token: string): void => localStorage.setItem('access_token', token);
export const clearAccessToken = (): void => localStorage.removeItem('access_token');

export const getUser = (): User | null => {
  const raw = localStorage.getItem('user_data');
  return raw ? (JSON.parse(raw) as User) : null;
};

export const setUser = (user: User): void => localStorage.setItem('user_data', JSON.stringify(user));
export const clearUser = (): void => localStorage.removeItem('user_data');
export const clearSelectedCust = (): void => localStorage.removeItem('selectedCustId');

export const isAuthenticated = (): boolean => !!getAccessToken();
